module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "departmentContainer": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('center', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.departmentLoader == true) ? _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.departmentLoader == false) ? _c('v-tabs', {
    staticClass: "departmentEditTabs",
    attrs: {
      "slider-color": "grey"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Details")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Calculator")]), _vm._v(" "), _c('v-tab', {
    key: 3,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Product Codes")]), _vm._v(" "), _c('v-tab', {
    key: 4,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("User List")]), _vm._v(" "), _c('v-tab', {
    key: 5,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Status Rules")]), _vm._v(" "), _c('v-tab', {
    key: 6,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Widget Rules")]), _vm._v(" "), _c('v-tab', {
    key: 7,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Quote Edit Screen")]), _vm._v(" "), _c('v-tab', {
    key: 8,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Article Margins")]), _vm._v(" "), _c('v-tab', {
    key: 9,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Delivery Note Setup")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Department Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Name",
      "required": "",
      "rules": _vm.nameRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.objDepartmentEdit.name),
      callback: function($$v) {
        _vm.$set(_vm.objDepartmentEdit, "name", $$v)
      },
      expression: "objDepartmentEdit.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Department Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Description",
      "required": "",
      "rules": _vm.descriptionRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.objDepartmentEdit.description),
      callback: function($$v) {
        _vm.$set(_vm.objDepartmentEdit, "description", $$v)
      },
      expression: "objDepartmentEdit.description"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Department Terms & Conditions Link:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Terms and Conditions",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.objDepartmentEdit.terms_and_conditions),
      callback: function($$v) {
        _vm.$set(_vm.objDepartmentEdit, "terms_and_conditions", $$v)
      },
      expression: "objDepartmentEdit.terms_and_conditions"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Can Edit Quotes For This Department:")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Can Edit Quotes For This Department"
    },
    model: {
      value: (_vm.objDepartmentEdit.hide_quote_edit),
      callback: function($$v) {
        _vm.$set(_vm.objDepartmentEdit, "hide_quote_edit", $$v)
      },
      expression: "objDepartmentEdit.hide_quote_edit"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Department Sales Margin:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Department Margin",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.objDepartmentEdit.department_margin),
      callback: function($$v) {
        _vm.$set(_vm.objDepartmentEdit, "department_margin", $$v)
      },
      expression: "objDepartmentEdit.department_margin"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Department Installation Margin:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Department Margin",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.objDepartmentEdit.department_installation_margin),
      callback: function($$v) {
        _vm.$set(_vm.objDepartmentEdit, "department_installation_margin", $$v)
      },
      expression: "objDepartmentEdit.department_installation_margin"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Can Update Sales Margin:")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Can Update Sales Margin"
    },
    model: {
      value: (_vm.objDepartmentEdit.can_update_sales_margin),
      callback: function($$v) {
        _vm.$set(_vm.objDepartmentEdit, "can_update_sales_margin", $$v)
      },
      expression: "objDepartmentEdit.can_update_sales_margin"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Can Update Installation Margin:")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Can Update Installation Margin"
    },
    model: {
      value: (_vm.objDepartmentEdit.can_update_installation_margin),
      callback: function($$v) {
        _vm.$set(_vm.objDepartmentEdit, "can_update_installation_margin", $$v)
      },
      expression: "objDepartmentEdit.can_update_installation_margin"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Can Update Sales Cost Price:")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Can Update Cost Price"
    },
    model: {
      value: (_vm.objDepartmentEdit.can_update_cost_price),
      callback: function($$v) {
        _vm.$set(_vm.objDepartmentEdit, "can_update_cost_price", $$v)
      },
      expression: "objDepartmentEdit.can_update_cost_price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Can Update Installation Cost Price:")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Can Update Installation Cost Price"
    },
    model: {
      value: (_vm.objDepartmentEdit.can_update_cost_price_installation),
      callback: function($$v) {
        _vm.$set(_vm.objDepartmentEdit, "can_update_cost_price_installation", $$v)
      },
      expression: "objDepartmentEdit.can_update_cost_price_installation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Show Spec Data in PO Document:")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Show Spec Data in PO Document"
    },
    model: {
      value: (_vm.objDepartmentEdit.show_po_spec),
      callback: function($$v) {
        _vm.$set(_vm.objDepartmentEdit, "show_po_spec", $$v)
      },
      expression: "objDepartmentEdit.show_po_spec"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("App Starting Status:")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.statusList,
      "placeholder": "App Starting Status",
      "item-value": "id",
      "item-text": "description",
      "autocomplete": "",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.objDepartmentEdit.app_starting_status),
      callback: function($$v) {
        _vm.$set(_vm.objDepartmentEdit, "app_starting_status", $$v)
      },
      expression: "objDepartmentEdit.app_starting_status"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Department Ranges:")]), _vm._v(" "), _c('div', {
    staticClass: "screenTip",
    staticStyle: {
      "margin": "16px"
    }
  }, [_c('span', [_c('i', {
    staticClass: "material-icons infoIcon",
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("information")]), _vm._v(" These are the calculators\n                    that will be available in the dropdowns on the Edit Quote Screen.\n                  ")])]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.departmentRangesList,
      "item-value": "id32",
      "rules": _vm.branchRules,
      "item-text": "name",
      "label": "Department Ranges",
      "autocomplete": "",
      "solo": "",
      "multiple": ""
    },
    model: {
      value: (_vm.objDepartmentEdit.ranges),
      callback: function($$v) {
        _vm.$set(_vm.objDepartmentEdit, "ranges", $$v)
      },
      expression: "objDepartmentEdit.ranges"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Department Starting Filter:")]), _vm._v(" "), _c('div', {
    staticClass: "screenTip",
    staticStyle: {
      "margin": "16px"
    }
  }, [_c('span', [_c('i', {
    staticClass: "material-icons infoIcon",
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("information")]), _vm._v("\n                    Each calculator will have a dropdown to allow filtering articles by product type.\n                    This filter is created by using the names of the properties in the MyQuote groupings. "), _c('br'), _vm._v("\n                    You can default the filter to the main product by adding the name of the product property as the starting filter.  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Example:")]), _vm._v(" In the laminated flooring calculator default the filter to show the laminated products by adding 'code_laminated flooring' as the starting filter.\n                  ")])]), _vm._v(" "), _c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.rangeHeaders,
      "items": _vm.rangeFilters,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "45%"
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.departmentRangesList,
            "item-value": "id32",
            "item-text": "name",
            "label": "Department Range",
            "autocomplete": "",
            "solo": ""
          },
          model: {
            value: (props.item.range),
            callback: function($$v) {
              _vm.$set(props.item, "range", $$v)
            },
            expression: "props.item.range"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "45%"
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Filter",
            "single-line": "",
            "solo": ""
          },
          model: {
            value: (props.item.filter),
            callback: function($$v) {
              _vm.$set(props.item, "filter", $$v)
            },
            expression: "props.item.filter"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeleteFilter(props.index)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])])])]
      }
    }], null, false, 422622908)
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.fncAddRangeFilter()
      }
    }
  }, [_vm._v("Add Range Filter")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 3,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "screenTip"
  }, [_c('span', [_c('i', {
    staticClass: "material-icons infoIcon",
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("information")]), _vm._v(" These are the codes/articles\n                    that will be available on the Edit Quote Screen. Find them in the calculator dropdown under the 'Made to Measure' option.\n                    "), _c('br'), _c('b', [_vm._v("NOTE: ")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("All articles added here will be editable on the Edit Quote Screen regardless of whether they were added using a\n                        calculator.")]), _vm._v(" "), _c('li', [_vm._v("The article will only display on the Edit Quote Screen if it is mapped to a vendor, the vendor is available for the store you are\n                        in and the article exists on M050. Store ranging does NOT apply to these articles.")]), _vm._v(" "), _c('li', [_vm._v("An installation article will display in the installation dropdown on the Edit Quote Screen if the article is added to the this screen as well as the installation\n                      list in MyOrder.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Make sure there are no blank fields as this will cause issues!")])])])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "articleImport"
    },
    on: {
      "change": _vm.fncSetImageObj
    }
  })]), _vm._v(" "), _vm._l((_vm.objDepartmentEdit.product_codes), function(product_code, index) {
    return _c('v-flex', {
      attrs: {
        "lg3": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Product Code",
        "single-line": "",
        "solo": ""
      },
      model: {
        value: (_vm.objDepartmentEdit.product_codes[index].value),
        callback: function($$v) {
          _vm.$set(_vm.objDepartmentEdit.product_codes[index], "value", $$v)
        },
        expression: "objDepartmentEdit.product_codes[index].value"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "departmentRangeRemove",
      on: {
        "click": function($event) {
          return _vm.fncRemoveDepartmentRange(index)
        }
      }
    }, [_vm._v("Remove")])], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddProductCode()
      }
    }
  }, [_vm._v("Add Product Code")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 4,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1 departmentUserList",
    attrs: {
      "loading": "true",
      "headers": _vm.headers,
      "items": _vm.departmentUsers,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "50%"
          }
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "50%"
          }
        }, [_vm._v(_vm._s(props.item.surname))])])]
      }
    }], null, false, 3524938664)
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 5,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.fncAddStatusRules
    }
  }, [_vm._v("Add Rule")])], 1), _vm._v(" "), (_vm.objDepartmentEdit.status_rules != null && _vm.objDepartmentEdit.status_rules != 'null' && _vm.objDepartmentEdit.status_rules.length > 0) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.ruleHeaders,
      "items": _vm.objDepartmentEdit.status_rules,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          staticStyle: {
            "margin-top": "4px !important"
          },
          attrs: {
            "items": _vm.serviceType,
            "placeholder": "Service Type",
            "item-value": "id",
            "item-text": "name",
            "outline": "",
            "autocomplete": ""
          },
          model: {
            value: (props.item.type),
            callback: function($$v) {
              _vm.$set(props.item, "type", $$v)
            },
            expression: "props.item.type"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          staticStyle: {
            "margin-top": "4px !important"
          },
          attrs: {
            "items": _vm.userRoles,
            "placeholder": "Roles",
            "item-value": "id",
            "item-text": "name",
            "multiple": "",
            "outline": "",
            "autocomplete": ""
          },
          model: {
            value: (props.item.originator),
            callback: function($$v) {
              _vm.$set(props.item, "originator", $$v)
            },
            expression: "props.item.originator"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          staticStyle: {
            "margin-top": "4px !important"
          },
          attrs: {
            "items": _vm.userRoles,
            "placeholder": "Roles",
            "item-value": "id",
            "item-text": "name",
            "multiple": "",
            "outline": "",
            "autocomplete": ""
          },
          model: {
            value: (props.item.roles),
            callback: function($$v) {
              _vm.$set(props.item, "roles", $$v)
            },
            expression: "props.item.roles"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          staticStyle: {
            "margin-top": "4px !important"
          },
          attrs: {
            "items": _vm.designationType,
            "placeholder": "Designation",
            "item-value": "id",
            "item-text": "name",
            "multiple": "",
            "outline": "",
            "autocomplete": ""
          },
          model: {
            value: (props.item.designation),
            callback: function($$v) {
              _vm.$set(props.item, "designation", $$v)
            },
            expression: "props.item.designation"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          staticStyle: {
            "margin-top": "4px !important"
          },
          attrs: {
            "items": _vm.statusList,
            "placeholder": "Status",
            "item-value": "id",
            "item-text": "description",
            "outline": "",
            "autocomplete": ""
          },
          model: {
            value: (props.item.status),
            callback: function($$v) {
              _vm.$set(props.item, "status", $$v)
            },
            expression: "props.item.status"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.fncDeleteStatusRule(props.item)
            }
          }
        }, [_vm._v("Delete")])])])]
      }
    }], null, false, 3531334264)
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 6,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "focusable": ""
    }
  }, _vm._l((_vm.objWidgetEdit.widgets), function(widget, key) {
    return _c('v-expansion-panel-content', {
      key: key,
      attrs: {
        "value": key === 'ESCALATION'
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function() {
          return [_vm._v(_vm._s(widget.title))]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('v-container', {
      attrs: {
        "grid-list-xs": "",
        "fluid": "",
        "widgetRules": ""
      }
    }, [_c('v-layout', {
      staticClass: "widgetRulesHeader"
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('div', {
      staticClass: "title pl-2 pr-2"
    }, [_vm._v("Group")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("Start Status")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("End Status")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("Period")])])], 1), _vm._v(" "), _vm._l((widget.groups), function(statusGroup) {
      return _c('v-layout', [_c('v-flex', {
        staticStyle: {
          "vertical-align": "center"
        },
        attrs: {
          "xs3": ""
        }
      }, [_c('div', {
        staticClass: "subheading pl-2 pr-2 pt-3"
      }, [_vm._v(_vm._s(statusGroup.label))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs3": ""
        }
      }, [_c('status-selector', {
        attrs: {
          "status-list": _vm.departmentStatuses,
          "label": "Select Initial Status",
          "selected-collection": typeof _vm.selectedWidgetStatusCollection[key] !== 'undefined' ? _vm.selectedWidgetStatusCollection[key] : []
        },
        model: {
          value: (statusGroup.status_initial),
          callback: function($$v) {
            _vm.$set(statusGroup, "status_initial", $$v)
          },
          expression: "statusGroup.status_initial"
        }
      })], 1), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs3": ""
        }
      }, [_c('status-selector', {
        attrs: {
          "status-list": _vm.departmentStatuses,
          "label": "Select End Status",
          "selected-collection": typeof _vm.selectedWidgetStatusCollection[key] !== 'undefined' ? _vm.selectedWidgetStatusCollection[key] : []
        },
        model: {
          value: (statusGroup.status_end),
          callback: function($$v) {
            _vm.$set(statusGroup, "status_end", $$v)
          },
          expression: "statusGroup.status_end"
        }
      })], 1), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs3": ""
        }
      }, [_c('period-selector', {
        model: {
          value: (statusGroup.period),
          callback: function($$v) {
            _vm.$set(statusGroup, "period", $$v)
          },
          expression: "statusGroup.period"
        }
      })], 1)], 1)
    })], 2)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 8,
    staticClass: "quoteEditScreen pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "10px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "screenTip"
  }, [_c('span', [_c('i', {
    staticClass: "material-icons infoIcon",
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("information")]), _vm._v(" Switch on the columns\n                    that are required on the Edit Quote Screen.\n                  ")])])]), _vm._v(" "), _c('h3', [_vm._v("GENERAL")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Can Add More Rows/Products")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.objDepartmentEdit.can_add_rows),
      callback: function($$v) {
        _vm.$set(_vm.objDepartmentEdit, "can_add_rows", $$v)
      },
      expression: "objDepartmentEdit.can_add_rows"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Calculator Dropdown")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.calculator),
      callback: function($$v) {
        _vm.calculator = $$v
      },
      expression: "calculator"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Select a product from a calculator that is mapped to this department. ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Location")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.location),
      callback: function($$v) {
        _vm.location = $$v
      },
      expression: "location"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Used to group line items on PDF")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h3', [_vm._v("PRODUCT")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Article Description")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.articleDescription),
      callback: function($$v) {
        _vm.articleDescription = $$v
      },
      expression: "articleDescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("BW Article No.")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.bwArticleNo),
      callback: function($$v) {
        _vm.bwArticleNo = $$v
      },
      expression: "bwArticleNo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Product Description")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.productDescription),
      callback: function($$v) {
        _vm.productDescription = $$v
      },
      expression: "productDescription"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Description captured in the template data and comes from the Spine.  ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Vendor")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.vendor),
      callback: function($$v) {
        _vm.vendor = $$v
      },
      expression: "vendor"
    }
  }), _vm._v(" "), _c('span', [_vm._v("As displayed in M050.  ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Product Code")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.plantCode),
      callback: function($$v) {
        _vm.plantCode = $$v
      },
      expression: "plantCode"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Used when Article Number is used for multiple products")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h3', [_vm._v("PRICING")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("UOM")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.uom),
      callback: function($$v) {
        _vm.uom = $$v
      },
      expression: "uom"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Unit Selling Price ( inc VAT )")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.unitTotalIncVat),
      callback: function($$v) {
        _vm.unitTotalIncVat = $$v
      },
      expression: "unitTotalIncVat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Unit Selling Price ( ex VAT )")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.unitSellingPriceExVat),
      callback: function($$v) {
        _vm.unitSellingPriceExVat = $$v
      },
      expression: "unitSellingPriceExVat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Total (inc VAT)")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.totalIncVat),
      callback: function($$v) {
        _vm.totalIncVat = $$v
      },
      expression: "totalIncVat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Vendor Unit Cost (ex VAT)")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.vendorUnitCostExVat),
      callback: function($$v) {
        _vm.vendorUnitCostExVat = $$v
      },
      expression: "vendorUnitCostExVat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Unit Vat")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.unitVat),
      callback: function($$v) {
        _vm.unitVat = $$v
      },
      expression: "unitVat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Margin")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.margin),
      callback: function($$v) {
        _vm.margin = $$v
      },
      expression: "margin"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h3', [_vm._v("HIRE/DELIVERY")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Hire Date")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.hireDate),
      callback: function($$v) {
        _vm.hireDate = $$v
      },
      expression: "hireDate"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Talisman Calc")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Hire Period")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.hirePeriod),
      callback: function($$v) {
        _vm.hirePeriod = $$v
      },
      expression: "hirePeriod"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Talisman Calc")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Delivery Method")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.deliveryMethod),
      callback: function($$v) {
        _vm.deliveryMethod = $$v
      },
      expression: "deliveryMethod"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Talisman Calc")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Receival Time")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.receivalTime),
      callback: function($$v) {
        _vm.receivalTime = $$v
      },
      expression: "receivalTime"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Talisman Calc")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 8,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg10": ""
    }
  }, [_c('div', {
    staticClass: "screenTip"
  }, [_c('span', [_c('i', {
    staticClass: "material-icons infoIcon",
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("information")]), _vm._v(" If there are articles that have a different margin to that set in the department you can set it here.\n                    "), _c('br'), _vm._v("If the margin can be edited for the department but there are certain articles "), _c('b', [_vm._v("can not be changed")]), _vm._v(" you\n                    can turn them off here.  "), _c('br'), _c('b', [_vm._v("NOTE:")]), _vm._v(" If the margins are set to NOT be editable at department level the below\n                    switches do not apply.\n                  ")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "articleMarginImport"
    },
    on: {
      "change": _vm.fncSetArticleMargins
    }
  })]), _vm._v(" "), _c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.marginHeaders,
      "items": _vm.objDepartmentEdit.article_margins,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow"
        }, [_c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Description",
            "single-line": "",
            "solo": ""
          },
          model: {
            value: (_vm.objDepartmentEdit.article_margins[props.index].description),
            callback: function($$v) {
              _vm.$set(_vm.objDepartmentEdit.article_margins[props.index], "description", $$v)
            },
            expression: "objDepartmentEdit.article_margins[props.index].description"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Product Code",
            "single-line": "",
            "solo": ""
          },
          model: {
            value: (_vm.objDepartmentEdit.article_margins[props.index].article),
            callback: function($$v) {
              _vm.$set(_vm.objDepartmentEdit.article_margins[props.index], "article", $$v)
            },
            expression: "objDepartmentEdit.article_margins[props.index].article"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Margin",
            "single-line": "",
            "solo": ""
          },
          model: {
            value: (_vm.objDepartmentEdit.article_margins[props.index].margin),
            callback: function($$v) {
              _vm.$set(_vm.objDepartmentEdit.article_margins[props.index], "margin", $$v)
            },
            expression: "objDepartmentEdit.article_margins[props.index ].margin"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_c('v-switch', {
          attrs: {
            "label": "Can Override Margin"
          },
          model: {
            value: (_vm.objDepartmentEdit.article_margins[props.index].override),
            callback: function($$v) {
              _vm.$set(_vm.objDepartmentEdit.article_margins[props.index], "override", $$v)
            },
            expression: "objDepartmentEdit.article_margins[props.index ].override"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_c('v-switch', {
          attrs: {
            "label": "Can Override Cost Price"
          },
          model: {
            value: (_vm.objDepartmentEdit.article_margins[props.index].override_cost),
            callback: function($$v) {
              _vm.$set(_vm.objDepartmentEdit.article_margins[props.index], "override_cost", $$v)
            },
            expression: "objDepartmentEdit.article_margins[props.index ].override_cost"
          }
        })], 1)])]
      }
    }], null, false, 65087476)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddProductCodeMargin()
      }
    }
  }, [_vm._v("Add Product Code Margin")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 9,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "screenTip"
  }, [_c('span', [_c('i', {
    staticClass: "material-icons infoIcon",
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("information")]), _vm._v(" Available shortcodes:"), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "delivery-Note-Tip-Table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": ""
    }
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("[ITEM]")])]), _vm._v(" "), _c('td', [_vm._v("name from line item data")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("[QUANTITY]")])]), _vm._v(" "), _c('td', [_vm._v("quantity from line item data")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("[MATERIAL]")])]), _vm._v(" "), _c('td', [_vm._v("material from line item data (boardcutting)")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("[COLOUR]")])]), _vm._v(" "), _c('td', [_vm._v("colour from line item data (boardcutting)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("[CUT_PIECES]")])]), _vm._v(" "), _c('td', [_vm._v("cut pieces from line item data (boardcutting)")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("[SHEETS]")])]), _vm._v(" "), _c('td', [_vm._v("sheets from line item data (boardcutting)")])])])])])]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.fncAddTemplate
    }
  }, [_vm._v("Add Row")]), _vm._v(" "), _c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1 departmentUserList",
    attrs: {
      "loading": "true",
      "headers": _vm.headersTemplate,
      "items": _vm.objDepartmentEdit.delivery_note_template,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "30%"
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Header",
            "single-line": "",
            "solo": ""
          },
          model: {
            value: (props.item.header),
            callback: function($$v) {
              _vm.$set(props.item, "header", $$v)
            },
            expression: "props.item.header"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "30%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          attrs: {
            "label": "Type",
            "items": _vm.templateItems,
            "item-value": "id",
            "item-text": "name",
            "autocomplete": "",
            "solo": "",
            "single-line": ""
          },
          model: {
            value: (props.item.value),
            callback: function($$v) {
              _vm.$set(props.item, "value", $$v)
            },
            expression: "props.item.value"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "30%"
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Shortcode",
            "single-line": "",
            "solo": ""
          },
          model: {
            value: (props.item.shortcode),
            callback: function($$v) {
              _vm.$set(props.item, "shortcode", $$v)
            },
            expression: "props.item.shortcode"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.fncDeleteTemplate(props.index)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])])])]
      }
    }], null, false, 3603010702)
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.addressSelected == false) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateDepartment()
      }
    }
  }, [_vm._v("Update")]) : _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": _vm.update_vars
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateDepartment()
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}